import React from "react";

/**
 * completed_qty 필드에 대해서만 변경 여부를 확인하는 함수
 * @param {Array} currentData - 현재 그리드 데이터 (rightGridData)
 * @param {Array} originalData - 원본 그리드 데이터 (rightOriginalData)
 * @returns {boolean} - 데이터 변경 여부 (true: 변경됨, false: 변경없음)
 */
export const isCompletedQtyChanged = (currentData, originalData) => {
  for (const currentRow of currentData) {
    const originalRow = originalData.find(
      (item) =>
        item.order_id === currentRow.order_id &&
        item.proc_id === currentRow.proc_id
    );
    if (!originalRow) {
      continue;
    }
    const normalizeValue = (value) => {
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      return typeof value === "string" ? Number(value) : value;
    };
    const currentQty = normalizeValue(currentRow.completed_qty);
    const originalQty = normalizeValue(originalRow.completed_qty);
    if (currentQty !== originalQty) {
      return true;
    }
  }
  return false;
};

/**
 * completed_qty 필드가 변경된 행만 추출하는 함수
 * @param {Array} currentData - 현재 그리드 데이터
 * @param {Array} originalData - 원본 그리드 데이터
 * @returns {Array} - 변경된 행 배열
 */
export const getCompletedQtyChangedRows = (currentData, originalData) => {
  if (!currentData?.length || !originalData?.length) return [];
  const originalMap = new Map();
  originalData.forEach((item) => {
    if (item.order_id && item.proc_id) {
      const key = `${item.order_id}_${item.proc_id}`;
      const normalizedValue =
        item.completed_qty === null ||
        item.completed_qty === undefined ||
        item.completed_qty === ""
          ? 0
          : Number(item.completed_qty);
      originalMap.set(key, {
        value: normalizedValue,
        row: item,
      });
    }
  });
  const changedRows = [];
  for (const currentRow of currentData) {
    if (!currentRow.order_id || !currentRow.proc_id) continue;
    const key = `${currentRow.order_id}_${currentRow.proc_id}`;
    if (!originalMap.has(key)) continue;
    const { value: originalValue, row: originalRow } = originalMap.get(key);
    const currentValue =
      currentRow.completed_qty === null ||
      currentRow.completed_qty === undefined ||
      currentRow.completed_qty === ""
        ? 0
        : Number(currentRow.completed_qty);
    if (currentValue !== originalValue) {
      changedRows.push({
        ...currentRow,
        _original: {
          completed_qty: originalValue,
        },
      });
    }
  }
  return changedRows;
};

export const progressCellRenderer = (params) => {
  if (!params.value && params.value !== 0) return "";
  const isError = params.data.isError;
  const percentValue = parseFloat(params.value);
  if (isNaN(percentValue)) return params.value;
  const containerStyle = {
    width: "100%",
    height: "36px",
    position: "relative",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    overflow: "hidden",
    margin: "5px 0",
    backgroundColor: "#f5f5f5",
  };
  const fillStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: `${Math.max(0, Math.min(100, percentValue))}%`,
    backgroundColor: isError === 1 ? "#ff8787" : "#a3f6ff",
    transition: "width 0.5s ease-in-out",
  };
  const textStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "13px",
    fontWeight: "bold",
    color: "#333333",
    // color: percentValue > 50 ? "#fff" : "#333333",
    zIndex: 1,
  };
  return (
    <div style={containerStyle}>
      <div style={fillStyle}></div>
      <div style={textStyle}>{percentValue}%</div>
    </div>
  );
};

export const getRightRowStyle = (params) => {
  const baseStyle = { zIndex: 5 };
  if (!params.data) return baseStyle;
  if (params.data.style_field === true && params.data.status !== 2) {
    return {
      ...baseStyle,
      backgroundColor: "#D5D2F7",
      color: "#d32f2f",
      fontStyle: "italic",
    };
  }
  if (params.data.style_field === true) {
    return {
      ...baseStyle,
      backgroundColor: "#D5D2F7",
      color: "white",
    };
  }
  if (params.data.status !== 2) {
    return {
      ...baseStyle,
      color: "#d32f2f",
      fontStyle: "italic",
    };
  }
  return baseStyle;
};
